import React from 'react';

import {
  createStyles,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Theme,
  withStyles,
  WithStyles,
} from '@material-ui/core';
import ExpansionPanel, { ExpansionPanelProps } from '@material-ui/core/ExpansionPanel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Typography from './Typography';

const styles = (theme: Theme) =>
  createStyles({
    panelRoot: {
      position: 'inherit',
    },
    panelExpanded: {
      margin: 0,
    },
    panelSummaryRoot: {
      minHeight: '0 !important',
      padding: `0 ${theme.spacing.unit * 2}px`,
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    panelSummaryContent: {
      margin: `${theme.spacing.unit}px 0 !important`,
    },
    panelSummaryExpandIcon: {
      right: theme.spacing.unit / 2,
      color: theme.palette.text.primary,
    },
    title: {
      fontWeight: 600,
    },
    panelDetails: {
      display: 'flex',
      flexDirection: 'column',
      padding: 0,
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  });

export interface FilterExpansionPanelProps extends Omit<ExpansionPanelProps, 'classes'>, WithStyles<typeof styles> {
  title: string;
}

const FilterExpansionPanel: React.FC<FilterExpansionPanelProps> = ({ classes, title, children, ...rest }) => (
  <ExpansionPanel
    classes={{
      root: classes.panelRoot,
      expanded: classes.panelExpanded,
    }}
    elevation={0}
    {...rest}
  >
    <ExpansionPanelSummary
      classes={{
        root: classes.panelSummaryRoot,
        content: classes.panelSummaryContent,
        expandIcon: classes.panelSummaryExpandIcon,
      }}
      expandIcon={<ExpandMoreIcon />}
    >
      <Typography className={classes.title} variant="subtitle1">
        {title}
      </Typography>
    </ExpansionPanelSummary>
    <ExpansionPanelDetails className={classes.panelDetails}>{children}</ExpansionPanelDetails>
  </ExpansionPanel>
);

export default withStyles(styles)(FilterExpansionPanel);
